export default {
  summary: 'Resumen',
  GeneralSummary: 'Datos Generales',
  invoiceId: 'Serie y número',
  format: 'Formato origen',
  created: 'Fecha de creación',
  onlySupplied: 'La factura es de solo suplido',
  ContactsSummary: 'Datos de interlocutores',
  provider: 'Datos del proveedor',
  client: 'Datos del cliente',
  agent: 'Datos del gestor',
  customer: 'Datos del comprador',
  DetailsSummary: 'Detalles de la factura',
  AmountsSummary: 'Importes Totales',
  FileSummary: 'Archivos adjuntos',
  title: 'Importes Totales',
  totalGross: 'Base imponible total',
  totalDisc: 'Total descuentos/cargos globales',
  totalTaxes: 'Total impuestos',
  totalOthers: 'Total pagos a cuenta, gastos reembolsables y otros',
  total: 'TOTAL',
  concept: 'Concepto',
  RequestFactoring: 'Financiación',
  requestFactoringTitle: 'Solicitar financiación con:',
  selectOption: 'Seleccione una opción',
  legal: 'Aceptar las condiciones para solicitar financiación',
  legalTextHeader: 'Para poder gestionar la solicitud de financiación usted acepta que se remitan los siguientes datos de sus facturas a la financiera:',
  conditions: {
    title: 'Condiciones para la aprobación de la financiación',
    error: 'No se cumplen las condiciones para poder realizar la financiación'
  },
  mandatory: 'Información obligatoria para la entidad financiera:'
}
